import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#000"
      fillOpacity={0.1}
      d="M-1546-665H828v-2h-2374zm2375 1v927h2v-927zm-1 928h-2374v2H828zm-2375-1v-927h-2v927zm1 1c-.55 0-1-.448-1-1h-2c0 1.657 1.34 3 3 3zm2375-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1-928a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm-2374-2c-1.66 0-3 1.343-3 3h2c0-.552.45-1 1-1z"
    />
    <path fill="#CEEDFF" d="M26 18a10 10 0 0 1-20 0C6 9 16 2 16 2s10 7 10 16" />
    <path
      fill="#278CFF"
      d="M21.75 5.969a31.8 31.8 0 0 0-5.181-4.788 1 1 0 0 0-1.148 0A31.8 31.8 0 0 0 10.25 5.97C6.814 9.915 5 14.075 5 18a11 11 0 1 0 22 0c0-3.925-1.814-8.085-5.25-12.031M16 27a9.01 9.01 0 0 1-9-9c0-7.153 6.934-13.125 9-14.75 2.066 1.625 9 7.594 9 14.75a9.01 9.01 0 0 1-9 9m6.986-7.832a7.2 7.2 0 0 1-5.82 5.819 1 1 0 1 1-.331-1.973c2.071-.349 3.829-2.106 4.18-4.181a1 1 0 1 1 1.973.335z"
    />
  </svg>
);
const SvgIconWeatherWaterColored = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherWaterColored);
export default Memo;
